import React, { useState } from 'react';

function scrollTo(id) { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); }

const cities = [
  { name: 'LOS ANGELES', state: 'California', date: 'Late May 2026 — Venue TBA', tier: 'Anchor City', short: 'LA' },
  { name: 'DALLAS', state: 'Texas', date: 'Late May / Early June 2026 — Venue TBA', tier: 'Anchor City', short: 'Dallas' },
  { name: 'SAN FRANCISCO', state: 'California', date: 'Early June 2026 — Venue TBA', tier: 'Pioneer City', short: 'SF' },
  { name: 'HAWAII', state: 'Hawaii', date: 'Early June 2026 — Venue TBA', tier: 'Pioneer City', short: 'Hawaii' },
  { name: 'LOUISIANA', state: 'Louisiana', date: 'Early June 2026 — Venue TBA', tier: 'Pioneer City', short: 'Louisiana' },
  { name: 'COLORADO', state: 'Colorado', date: 'Early June 2026 — Venue TBA', tier: 'Pioneer City', short: 'Colorado' },
  { name: 'ATLANTA', state: 'Georgia', date: 'Early June 2026 — Venue TBA', tier: 'Pioneer City', short: 'Atlanta' },
];

export default function Cities() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="cities" style={{ background: 'var(--ash)', padding: '120px 64px' }}>
      <style>{`
        @media(max-width:768px){ #cities{padding:80px 24px!important;} .cities-grid{grid-template-columns:1fr!important;} }
        .city-card-inner { transition: border-color 0.3s; }
        .city-card-inner:hover { border-color: rgba(200,68,10,0.4) !important; }
      `}</style>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 64, flexWrap: 'wrap', gap: 24 }}>
        <div>
          <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>2026 Tour</p>
          <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)' }}>
            REVIVE IS<br />COMING TO<br />YOUR CITY
          </h2>
        </div>
        <p className="reveal" style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 18, color: 'rgba(245,240,232,0.4)', maxWidth: 280, textAlign: 'right' }}>
          Eight cities. One mission.<br />A nation awakened city by city.
        </p>
      </div>

      <div className="cities-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 2 }}>
        {cities.map((city, i) => (
          <div key={city.name} className={`reveal reveal-d${Math.min(i + 1, 4)}`}
            style={{ position: 'relative', cursor: 'pointer' }}
            onClick={() => scrollTo('register')}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}>
            <div className="city-card-inner" style={{
              padding: '40px 32px',
              border: '1px solid rgba(200,68,10,0.1)',
              background: hovered === i ? 'rgba(200,68,10,0.06)' : 'rgba(8,8,8,0.5)',
              height: '100%',
              position: 'relative', overflow: 'hidden',
              transition: 'all 0.3s',
            }}>
              {hovered === i && <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg,rgba(200,68,10,0.08),transparent)', pointerEvents: 'none' }} />}
              <span style={{ display: 'inline-block', fontSize: 9, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'var(--ember)', border: '1px solid rgba(200,68,10,0.3)', padding: '4px 10px', marginBottom: 20 }}>
                {city.tier}
              </span>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px,4vw,42px)', letterSpacing: '0.05em', color: 'var(--white)', lineHeight: 1, marginBottom: 6 }}>{city.name}</div>
              <div style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.35)', marginBottom: 20 }}>{city.state}</div>
              <div style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 15, color: 'var(--gold)', marginBottom: 28 }}>{city.date}</div>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: hovered === i ? 14 : 8, fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--ember)', transition: 'gap 0.3s' }}>
                Register for REVIVE {city.short} →
              </span>
            </div>
          </div>
        ))}
        <div className="reveal" style={{ padding: '40px 32px', border: '1px solid rgba(200,68,10,0.2)', background: 'rgba(200,68,10,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 28, color: 'var(--ember)', marginBottom: 10 }}>MORE TO COME</div>
            <div style={{ fontSize: 13, color: 'rgba(245,240,232,0.35)' }}>Stay connected for future city announcements</div>
          </div>
        </div>
      </div>
    </section>
  );
}
